import { render, staticRenderFns } from "./ProductSingleApplication.vue?vue&type=template&id=1bba5a20&"
import script from "./ProductSingleApplication.vue?vue&type=script&lang=js&"
export * from "./ProductSingleApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports